module.exports = __webpack_public_path__ + "static/media/transparent_step2@2x.f385bee3.png";